import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function AutomaticMachines() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/automatiske-maskiner-montage.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-e4773b90d5d84e7d9a79c755c2e3476b-mv2.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/hero-automation-engineering.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-01b2b211d5ea4244916831dd44ab4a7b-mv2.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Automatiske maskiner - JARCon ApS"
        description="Udvikling og levering af automatiske maskiner og procesceller. Mekanik, el og automation samlet i én leverance."
      />

      <PageHeader
        badge="Automation"
        title="Automatiske maskiner"
        subtitle="Udvikling og levering af automatiske maskiner og kundetilpassede produktionsanlæg"
        breadcrumbs={[
          { label: 'Automation', path: '/automation' },
          { label: 'Automatiske maskiner' },
        ]}
        ctaText="Hør om maskinudvikling"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Skræddersyede automationsmaskiner
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Udvikling og levering af automatiske maskiner
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Når standardudstyr ikke slår til, udvikler JARCon specialmaskiner tilpasset specifikke emner, cyklustider og pladsforhold.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Fra simple hjælpeaggregater og emnefødere til fuldautomatiske procesceller med servodrev, pneumatik, sensorovervågning og sikkerhedsafskærmning.
              </p>
            </div>

            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <h3 className="font-display text-xl font-bold text-white">
                Fra specifikation til afprøvning
              </h3>
              <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
                Vi varetager maskinens komplette livscyklus: mekanisk 3D konstruktion i Inventor, valg af lineære komponenter og drev, bygning af styretavle, programmering af PLC og sikkerhed samt grundig afprøvning inden levering.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 font-open-sans text-xs">
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800">
                  <span className="text-cyan-400 font-semibold block mb-1">Mekanisk konstruktion</span>
                  <span className="text-slate-400">Modulære profiler, præcisionsbearbejdede emner og slidstærke overflader</span>
                </div>
                <div className="p-4 rounded-lg bg-[#080d14] border border-slate-800">
                  <span className="text-cyan-400 font-semibold block mb-1">Styring &amp; Sikkerhed</span>
                  <span className="text-slate-400">Nødstopsystemer, lysgitre, sensorik og CE-mærkning</span>
                </div>
              </div>
            </div>

            <GalleryGrid
              title="Automatiske maskiner galleri"
              subtitle="Klik på billederne for at åbne i fuld skærm"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Maskintyper &amp; Løsninger
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Automatiske montagemaskiner</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Emnefødere og lineærsystemer</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Automationsudstyr til skolebrug</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Pneumatiske og servobaserede anlæg</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>CE mærkning og risikovurdering</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Har du en maskinidé?
              </span>
              <p className="text-xs text-slate-300">
                Lad os gennemgå dit behov og estimere en prototype eller serieproduktion.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
